var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFikanalytcs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 789 362",
    style: {
      enableBackground: "new 0 0 789 362"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2B9BC6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M391.6,224.6h-66.9c-6.9,0-12.6-5.4-12.6-12.1V0h67.7c6.5,0,11.8,5.1,11.8,11.3L391.6,224.6L391.6,224.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M680.1,101.1c-4.5,4.4-4.5,11.5,0,15.9L789,222.4v2.1H688.4c-3.1,0-6-1.2-8.2-3.2l-72.4-75.6 c-2.2-2.1-5.1-3.2-8.2-3.2h-55.3c-6.5,0-11.8,5-11.8,11.3v59.4c0,6.2-5.3,11.3-11.8,11.3h-51.7c-6.5,0-11.8-5-11.8-11.3v-202 c0-6.2,5.3-11.3,11.8-11.3h51.7c6.5,0,11.8,5,11.8,11.3v57.9c0,6.2,5.3,11.3,11.8,11.3H599c3,0,6-1.1,8.2-3.1l94.2-74.2 c2.2-2,5.1-3.1,8.2-3.1h72.8v2.1L680.1,101.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.6,0v59.7H82.8c-6.5,0-9.7,3.3-9.7,10l0.2,11.2h173.3v58.9H85.8c-6.9,0-12.6,5.4-12.6,12l-0.9,72.9H0 V41.2C0,13.7,14.1,0,42.3,0L246.6,0L246.6,0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "510.6,357.8 508.6,357.8 508.6,258.4 567.1,258.4 567.1,260.4 510.6,260.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "517.5,357.8 515.5,357.8 515.5,264.8 567.1,264.8 567.1,266.9 517.5,266.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "524.9,357.8 522.9,357.8 522.9,271.8 567.1,271.8 567.1,273.8 524.9,273.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "531.9,357.8 529.9,357.8 529.9,277.9 567.1,277.9 567.1,279.9 531.9,279.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 469.4,
    y: 258.4,
    className: "st0",
    width: 35.8,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 469.4,
    y: 264.9,
    className: "st0",
    width: 35.8,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 469.3,
    y: 271.4,
    className: "st0",
    width: 35.8,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 469.4,
    y: 277.9,
    className: "st0",
    width: 35.8,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 464.7,
    y: 257,
    className: "st0",
    width: 4.7,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M469.8,262.1h-5.4v-5.4h5.4V262.1z M465,261.4h4.1v-4.1H465V261.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 464.7,
    y: 263.6,
    className: "st0",
    width: 4.7,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M469.8,268.6h-5.4v-5.4h5.4V268.6z M465,268h4.1v-4.1H465V268z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 464.7,
    y: 276.5,
    className: "st0",
    width: 4.7,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M469.8,281.6h-5.4v-5.4h5.4V281.6z M465,280.9h4.1v-4.1H465V280.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 464.7,
    y: 269.8,
    className: "st0",
    width: 4.7,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M469.8,274.9h-5.4v-5.4h5.4V274.9z M465,274.2h4.1v-4.1H465V274.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 565,
    y: 257,
    className: "st0",
    width: 4.7,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M570.1,262.1h-5.4v-5.4h5.4V262.1z M565.4,261.4h4.1v-4.1h-4.1V261.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 565,
    y: 263.6,
    className: "st0",
    width: 4.7,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M570.1,268.6h-5.4v-5.4h5.4V268.6z M565.4,268h4.1v-4.1h-4.1V268z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 564.9,
    y: 270,
    className: "st0",
    width: 4.7,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M570,275.1h-5.4v-5.4h5.4V275.1z M565.3,274.4h4.1v-4.1h-4.1V274.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 565,
    y: 276.5,
    className: "st0",
    width: 4.7,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M570.1,281.6h-5.4v-5.4h5.4V281.6z M565.4,280.9h4.1v-4.1h-4.1V280.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 528.6,
    y: 355.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 888.8119 -173.0508)",
    className: "st0",
    width: 4.7,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M533.6,360.6h-5.4v-5.4h5.4V360.6z M528.9,359.9h4.1v-4.1h-4.1V359.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 521.6,
    y: 355.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 881.8093 -166.0482)",
    className: "st0",
    width: 4.7,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M526.6,360.6h-5.4v-5.4h5.4V360.6z M521.9,359.9h4.1v-4.1h-4.1V359.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 514.4,
    y: 355.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 874.6063 -158.9545)",
    className: "st0",
    width: 4.7,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M519.5,360.5h-5.4v-5.4h5.4V360.5z M514.7,359.9h4.1v-4.1h-4.1V359.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 507.3,
    y: 355.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 867.4577 -151.806)",
    className: "st0",
    width: 4.7,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512.3,360.5h-5.4v-5.4h5.4V360.5z M507.6,359.9h4.1v-4.1h-4.1V359.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.5,332.9l-7.3,26.3H0.3l31.3-102.6H62l32,102.6H68.9L61,332.9H31.5z M57.6,315.5l-6.4-21.8 c-1.8-6.1-3.7-13.7-5.2-19.8h-0.3c-1.5,6.1-3.1,13.9-4.7,19.8l-6.1,21.8H57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.7,359.2V256.6h27.2l21.4,37.6c6.1,10.8,12.1,23.6,16.8,35.2h0.3c-1.4-13.6-1.8-27.4-1.8-42.9v-29.9 h21.4v102.6h-24.4l-22-39.6c-6.1-11-13-24.2-17.8-36.2H128c0.8,13.7,1.1,28.2,1.1,44.9v30.9H107.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.9,332.9l-7.3,26.3h-23.9l31.3-102.6h30.5l32,102.6h-25.2l-7.9-26.3H236.9z M263,315.5l-6.4-21.8 c-1.8-6.1-3.7-13.7-5.2-19.8h-0.3c-1.5,6.1-3.1,13.9-4.7,19.8l-6.1,21.8H263z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.2,256.6h23.2v83.2h40.9v19.5h-64.1V256.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M401,359.2v-42l-32.5-60.6h26.7l10.4,24.7c3.2,7.5,5.5,12.9,7.9,19.6h0.3c2.3-6.4,4.7-12.3,7.8-19.6 l10.4-24.7h26.1l-33.9,59.9v42.8H401z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M610.5,257.7v102.6h-23.2V257.7H610.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M706,357.6c-4.1,2-13.9,4.4-26.2,4.4c-35.5,0-53.8-22.2-53.8-51.5c0-35,25-54.4,56.1-54.4 c12,0,21.2,2.3,25.3,4.6l-4.9,18.3c-4.6-2-11.1-3.8-19.5-3.8c-18.3,0-32.6,11.1-32.6,34c0,20.6,12.2,33.5,32.8,33.5 c7.2,0,14.8-1.4,19.5-3.4L706,357.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M722.2,336.4c6.1,3.2,15.9,6.4,25.8,6.4c10.7,0,16.3-4.4,16.3-11.1c0-6.4-4.9-10.1-17.2-14.3 c-17.1-6.1-28.4-15.5-28.4-30.5c0-17.5,14.8-30.8,38.9-30.8c11.7,0,20.1,2.3,26.2,5.2l-5.2,18.6c-4-2-11.4-4.9-21.4-4.9 c-10.1,0-14.9,4.7-14.9,9.9c0,6.6,5.6,9.4,19.1,14.5c18.2,6.7,26.5,16.1,26.5,30.6c0,17.2-13.1,31.8-41.3,31.8 c-11.7,0-23.3-3.2-29.1-6.4L722.2,336.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFikanalytcs);
export default __webpack_public_path__ + "static/media/FIK ANALYTCS.def7c8d303e61b78e5f27bedd5da421a.svg";
export { ForwardRef as ReactComponent };